// extracted by mini-css-extract-plugin
module.exports = {"p1em":"GeneralTasksList_p1em__MVKyQ","searchTop":"GeneralTasksList_searchTop__1jtdl","searchBar":"GeneralTasksList_searchBar__2bnS_"};